import { INITIAL_BUSINESS_REQUEST, FETCH_BUSINESS_SUCCESS, FINAL_BUSINESS_REQUEST } from "../../types/maintainers/business.type";

const initialState = {
	business: [],
	customers: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_business(state = initialState, action) {
	switch (action.type) {
		case INITIAL_BUSINESS_REQUEST:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_BUSINESS_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				business: action.payload.business,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		case FINAL_BUSINESS_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		default:
			return state;
	}
}

export default maintainers_business;
